// Imports
import { create } from "zustand";
// Do not use simple-zustand-devtools here: it createRoot()s a second React tree
// and under Next 16 / React 19 that silently breaks app-wide click handlers.

// State
const useStore = create((set) => ({
  sortBy: "",
  selectedDay: { slug: "all-days", label: "All Events" },
  selectedTimePeriod: "All",
  searchTerm: "",
  activeCategories: [],
  activeLocations: [],
  activeTypes: [],
  pageBy: 96,
  currentPage: 1,
  showBanner: false,
  isMobileMenuOpen: false,
  toggleMobileMenu: () =>
    set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  setMobileMenuOpen: (isMobileMenuOpen) => set({ isMobileMenuOpen }),
  setSortBy: (sortBy) => set({ sortBy }),
  setSelectedDay: (selectedDay) => set({ selectedDay }),
  setDayFilter: (selectedDay) => set({ selectedDay, currentPage: 1 }),
  setSelectedTimePeriod: (selectedTimePeriod) => set({ selectedTimePeriod }),
  setSearchTerm: (searchTerm) => set({ searchTerm }),
  setActiveCategories: (activeCategories) =>
    set({ activeCategories: activeCategories ?? [] }),
  setActiveLocations: (activeLocations) =>
    set({ activeLocations: activeLocations ?? [] }),
  setActiveTypes: (activeTypes) => set({ activeTypes: activeTypes ?? [] }),
  setPageBy: (pageBy) => set({ pageBy }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setShowBanner: (showBanner) => set({ showBanner }),
  isMyShowOpen: false,
  toggleMyShow: () => set((state) => ({ isMyShowOpen: !state.isMyShowOpen })),
  setIsMyShowOpen: (isMyShowOpen) => set({ isMyShowOpen }),

  isMyShowMobileOpen: false,
  toggleMyShowMobile: () =>
    set((state) => ({ isMyShowMobileOpen: !state.isMyShowMobileOpen })),
  setIsMyShowMobileOpen: (isMyShowMobileOpen) => set({ isMyShowMobileOpen }),

  isMobileMapDrawerOpen: false,
  toggleMobileMapDrawer: () =>
    set((state) => ({ isMobileMapDrawerOpen: !state.isMobileMapDrawerOpen })),
  setIsMobileMapDrawerOpen: (isMobileMapDrawerOpen) =>
    set({ isMobileMapDrawerOpen }),
}));

export default useStore;
